function isAppPath(value: string): boolean {
	return value.startsWith('/');
}

export function collectAppRoutePaths(routes: object): string[] {
	return Object.values(routes).flatMap((value) => {
		if (typeof value === 'string') {
			return isAppPath(value) ? [value] : [];
		}

		if (typeof value === 'object' && value !== null) {
			return collectAppRoutePaths(value);
		}

		return [];
	});
}
